(function(){
  'use strict';
  if(window.__EWMerchV6)return;
  window.__EWMerchV6=1;

  var V='2026.08.15-stable-no-rehydrate';

  /*
    AINAK WEAR — PRODUCT CARD STABILITY MODE

    Retired the legacy client-side merchandising authority that fetched
    collection JSON after first paint and repeatedly rewrote visible cards.
    The old runtime changed product handles, links, titles, images, prices,
    discount labels and badges at 300/900/2000/4500ms and from a broad
    MutationObserver. Combined with the older latest-first authority, this
    produced the visible Ray-Ban -> Tom Ford style teleport/glitch.

    Product identity/order is now owned by the Shopify/Liquid render and the
    dedicated section/slider code. This compatibility shell deliberately does
    not mutate or reorder any already-rendered product card.
  */

  function ready(){
    document.documentElement.classList.add(
      'ew-merch-home-ready-v5',
      'ew-merch-home-ready-v6',
      'ew-merch-collection-ready-v5',
      'ew-merch-collection-ready-v6',
      'ew-pdp-recommendations-ready-v2',
      'ew-pdp-recommendations-ready-v5',
      'ew-pdp-recommendations-ready-v6',
      'ew-merchandising-ready-v6'
    );
  }

  ready();
  window.EWMerchandisingAuthorityV6={
    refresh:ready,
    version:V
  };
})();
